export default "/_next/static/chunks/fonts/Channel4Chadwick-Light-2304ec9e4f265fd16304087b1d56e33c.woff2";